import { Paragraph, TextRun } from "docx";
import generateLvTableRow from "./generateLvTableRow";

export default function generateConstructionSiteSetupRow(positionNumber) {
  const textRuns = [
    new TextRun({
      text: "Baustelleneinrichtung",
      bold: true,
    }),
    new TextRun({
      text: "Einmalige Baustelleneinrichtung und –räumung aller Geräte für das Herstellen von Mikropfählen nach Unterlagen des AG und den nachfolgend aufgeführten Positionen.",
      break: 1,
    }),
    new TextRun({
      text: "Einzurechnen sind alle Transporte, An- und Abreise des Personals, sowie Personal- und Vorhaltekosten während der Einrichtungs- und Räumungszeit.",
      break: 1,
    }),
    new TextRun({
      text: "Mehrmaliges Umsetzen und Einbringen an verschiedenen Stellen im Bereich des Bauwerks wird nicht gesondert vergütet.",
      break: 1,
    }),
    new TextRun({
      text: "Projektbezogene Hinweise ergänzen:",
      break: 2,
      color: "6E6E6E",
      italics: true,
    }),
    new TextRun({
      text: "Randbedingungen: wie z.B. Lage der Bohransatzpunkte; Arbeitsraumbreite; mögliche Höhenbeschränkungen; Zufahrtsmöglichkeiten und Zufahrtsbreiten können hier oder in den Vorbemerkungen beschrieben werden, eventuell mit Verweis auf Pläne",
      break: 1,
      color: "6E6E6E",
      italics: true,
    }),
  ];

  const descriptionParagraph = new Paragraph({
    children: textRuns,
  });

  return generateLvTableRow(positionNumber, descriptionParagraph, "1", "psch.");
}
